import { render, staticRenderFns } from "./ChangeRegionModal.vue?vue&type=template&id=6ae889fe&scoped=true"
import script from "./ChangeRegionModal.vue?vue&type=script&lang=js"
export * from "./ChangeRegionModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeRegionModal.vue?vue&type=style&index=0&id=6ae889fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae889fe",
  null
  
)

export default component.exports